export default "__VITE_ASSET__DjlIo8Ei__"